import PortalCard from "./PortalCard";

export default PortalCard;
